module.exports = __webpack_public_path__ + "static/media/vic-logo.7862e95b.png";